import React, {Component} from 'react';
import WOW from 'wowjs';
import AdminHomeTableTransactions from './admin-home-table-transactions';
import AdminHomeTableProfile from './admin-home-table-profile';
import AdminHomeTableUsers from './admin-home-table-users';
import AdminHomeTableStudies from './admin-home-table-studies';
import AdminHomeTableMessages from './admin-home-table-messages';
import AdminHomeTableSubscribers from './admin-home-table-subscribers';
import AdminHomeTableCaseSlider from './admin-home-table-case-studies-slider';
import AdminHomeTableTestmonialsSlider from './admin-home-table-testmonials-slider';
import AddNewUser from '../AdminModals/add-new-user';
import AddNewCaseStudySlider from '../AdminModals/add-new-case-study-slider';
import AddNewTestmonialsSlider from '../AdminModals/add-new-testmonials-slider';
import DeleteDialougeModal from '../AdminModals/delete-dialouge-model';
import EditModalDialouge from '../AdminModals/edit-dialouge-modal';
import ViewModalDialouge from '../AdminModals/view-dialouge-modal';


class AdminHomeTable extends Component{

    componentDidMount() {
        new WOW.WOW().init();
      }

    render(){

        return(
            <div className="my-account-admin">
                <div className="container-fluid">
                   <div className="my-account-title">حساب الأدمن</div>
                    <div className="my-account-main">
                        <div className="row justify-content-center text-align-center space- ">
                            <div className="col-lg-2">

                                <ul className="nav flex-column nav-tabs main-tabs-admin" id="myAccount"  aria-orientation="vertical" role="tablist">
                                        <li className="nav-item"> <a className="nav-link active" id="allusers-tab" data-toggle="tab" href="#allUsers" role="tab" aria-selected="true">المستخدمين</a> </li>
                                        <li className="nav-item"> <a className="nav-link" id="transactions-tab" data-toggle="tab" href="#transactions" role="tab"  aria-selected="false">المعاملات</a> </li>
                                        <li className="nav-item"> <a className="nav-link" id="studies-tab" data-toggle="tab" href="#studies" role="tab"  aria-selected="false">الدراسات</a> </li>
                                        <li className="nav-item"> <a className="nav-link" id="caseStudies-tab" data-toggle="tab" href="#caseStudies" role="tab"  aria-selected="false">دراسة الحالات </a> </li>
                                        <li className="nav-item"> <a className="nav-link" id="testmonilas-tab" data-toggle="tab" href="#testmonilas" role="tab"  aria-selected="false">أراء العملاء </a> </li>
                                        <li className="nav-item"> <a className="nav-link" id="subscribers-tab" data-toggle="tab" href="#subscribers" role="tab"  aria-selected="false">المشتركين </a> </li>
                                        <li className="nav-item"> <a className="nav-link" id="messages-tab" data-toggle="tab" href="#messages" role="tab"  aria-selected="false">الرسائل </a> </li>
                                        <li className="nav-item"> <a className="nav-link"  href="/home" onClick = {() => localStorage["token"] = "null" } >تسجيل الخروح </a> </li>
                                </ul>
                            
                            </div>
                            <div className="col-lg-10">
                                <div className="tab-content" id="myAccountContent">
                                    <AdminHomeTableUsers/>
                                    <AdminHomeTableTransactions/>
                                    <AdminHomeTableStudies/>
                                    <AdminHomeTableProfile/>
                                    <AdminHomeTableMessages/>
                                    <AdminHomeTableSubscribers/>
                                    <AdminHomeTableCaseSlider/>
                                    <AdminHomeTableTestmonialsSlider/>


                                    {/* Modals */}
                                    <AddNewUser/>
                                    <AddNewCaseStudySlider/>
                                    <AddNewTestmonialsSlider/>
                                    <DeleteDialougeModal/>
                                    <EditModalDialouge/>
                                    <ViewModalDialouge/>

                                </div>
                            </div>  
                        </div>
        
                   
                    </div>
        
                
                </div>
            </div>
            
        );
       
    }

};
export default AdminHomeTable;


